import { sortArrayBy } from '@domain-group/javascript-utils'

import type { EntitiesState } from '@redux/entities'

import { agencyTeamMemberSort } from '@functions/teamMember'

import type { TeamModel } from '@models/types'

const adminRoles = ['office_support', 'remote_support']
export const agentRoles = ['associate_agent', 'lead_agent']

type GetTeamAdminUsersParams = {
  team: TeamModel,
  teamMembers: EntitiesState['teamMembers'],
  users: EntitiesState['users'],
}

export function getTeamAdminUsers(params: GetTeamAdminUsersParams) {
  const { team, teamMembers, users } = params
  if (!team || !team.team_members) return []

  const adminUsers = team.team_members.map((memberId) => {
    const member = teamMembers[memberId] || {}
    const user = users[member.user_id] || {}

    if (adminRoles.includes(member.member_role)){
      return user
    }

    return null
  }).filter(user => user)

  return sortArrayBy(adminUsers, 'asc', user => user?.full_name)
}

type GetTeamAgentsParams = {
  team: TeamModel,
  teamMembers: EntitiesState['teamMembers'],
  users: EntitiesState['users'],
}

export function getTeamAgents(params: GetTeamAgentsParams) {
  const { team, teamMembers, users } = params
  if (!team) return {}

  const filteredTeamMembers = Object.values(teamMembers).filter(
    member => member.team_id === team.id && agentRoles.includes(member.member_role),
  )

  const members = filteredTeamMembers.map((member) => {
    const user = users[member.user_id] || {}

    return {
      actableId: user.actable_id,
      actableType: user.actable_type,
      teamRole: member.member_role,
      // @ts-expect-error TS7053
      sort: agencyTeamMemberSort[member.member_role],

    }
  })

  return {
    members,
    // @ts-expect-error TS7053
    teamAgentIds: sortArrayBy(members, 'asc', member => agencyTeamMemberSort[member.member_role]).map(m => m.actableId),
  }
}

export default getTeamAgents
